import React from 'react';
import { CreditCard, ArrowRight, Shield, Lock, CheckCircle } from 'lucide-react';

const PaymentCenterCTA = () => {
  return (
    <section 
      className="py-16 md:py-20 bg-gray-50 border-t border-gray-200"
      data-testid="payment-center-cta"
    >
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="mb-10">
          <div className="w-16 h-16 bg-[#C9A227]/10 flex items-center justify-center mx-auto mb-6">
            <CreditCard className="w-8 h-8 text-[#C9A227]" />
          </div>
          <h2 className="text-3xl md:text-4xl font-light text-black mb-4">
            Payment Center
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Make secure payments on your existing invoice or estimate. Fast, simple, and protected.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mb-10">
          <div className="flex items-center gap-2 text-gray-600 text-sm">
            <Shield className="w-4 h-4 text-[#1e3a5f]" />
            <span>SSL Secured</span>
          </div>
          <div className="flex items-center gap-2 text-gray-600 text-sm">
            <Lock className="w-4 h-4 text-[#1e3a5f]" />
            <span>256-bit Encryption</span>
          </div>
          <div className="flex items-center gap-2 text-gray-600 text-sm">
            <CheckCircle className="w-4 h-4 text-[#1e3a5f]" />
            <span>PCI Compliant</span>
          </div>
        </div>

        <a
          href="/payment-center"
          className="inline-flex items-center gap-3 px-10 py-4 bg-[#1e3a5f] text-white text-sm tracking-wide uppercase font-medium hover:bg-black transition-colors group"
          data-testid="payment-center-btn"
        >
          Make a Payment
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </a>

        <p className="text-gray-400 text-sm mt-6">
          Accepted: Visa, MasterCard, American Express
        </p>
      </div>
    </section>
  );
};

export default PaymentCenterCTA;
